import Layout from "../components/Layout";
import PageHeader from "../components/PageHeader";

const PrivacyPage = () => {
  return (
    <Layout>
      <PageHeader
        title="Politika zasebnosti"
        description="Informacije o tem, kako ravnamo z vašimi podatki."
      />
      
      <div className="container mx-auto py-12 md:py-16 px-6 md:px-8">
        <div className="max-w-3xl mx-auto prose prose-lg">
          <h2 className="text-2xl font-bold mb-6">Politika zasebnosti</h2>
          
          <p>Spodaj je navedena politika zasebnosti klinike Dr. Danijela Novaka. Z uporabo naše spletne strani in storitev se strinjate z našo politiko zasebnosti.</p>
          
          <h3 className="text-xl font-bold mt-8 mb-4">1. Zbiranje podatkov</h3>
          <p>Zbiramo naslednje osebne podatke:</p>
          <ul>
            <li>Ime in priimek</li>
            <li>Kontaktne podatke (e-pošta, telefonska številka)</li>
            <li>Zdravstvene podatke, ki so relevantni za posege in storitve, za katere se zanimate</li>
            <li>Druge podatke, ki nam jih prostovoljno posredujete</li>
          </ul>
          
          <h3 className="text-xl font-bold mt-8 mb-4">2. Namen zbiranja podatkov</h3>
          <p>Vaše podatke zbiramo in obdelujemo za naslednje namene:</p>
          <ul>
            <li>Za zagotavljanje storitev, ki jih zahtevate</li>
            <li>Za komunikacijo v zvezi z vašimi poizvedbami in rezervacijami</li>
            <li>Za izboljšanje naših storitev</li>
            <li>Za izpolnitev naših zakonskih obveznosti</li>
          </ul>
          
          <h3 className="text-xl font-bold mt-8 mb-4">3. Hramba podatkov</h3>
          <p>Vaše osebne podatke hranimo le toliko časa, kolikor je potrebno za izpolnitev namenov, za katere so bili zbrani, ali za izpolnitev zakonskih zahtev. Zdravstvene podatke hranimo v skladu z zakonsko določenimi roki za hranjenje zdravstvene dokumentacije.</p>
          
          <h3 className="text-xl font-bold mt-8 mb-4">4. Varnost podatkov</h3>
          <p>Zavezujemo se k varovanju zasebnosti vaših osebnih podatkov. Izvajamo ustrezne fizične, tehnične in organizacijske ukrepe za zaščito vaših osebnih podatkov pred nepooblaščenim dostopom, izgubo ali zlorabo.</p>
          
          <h3 className="text-xl font-bold mt-8 mb-4">5. Deljenje podatkov</h3>
          <p>Vaših osebnih podatkov ne bomo delili s tretjimi osebami, razen v naslednjih primerih:</p>
          <ul>
            <li>Če je to potrebno za izvajanje storitev, ki ste jih zahtevali</li>
            <li>Če to zahteva zakon</li>
            <li>Z vašim izrecnim soglasjem</li>
          </ul>
          
          <h3 className="text-xl font-bold mt-8 mb-4">6. Vaše pravice</h3>
          <p>V zvezi z vašimi osebnimi podatki imate naslednje pravice:</p>
          <ul>
            <li>Pravico do dostopa do vaših osebnih podatkov</li>
            <li>Pravico do popravka netočnih ali nepopolnih podatkov</li>
            <li>Pravico do izbrisa vaših osebnih podatkov (»pravica do pozabe«)</li>
            <li>Pravico do omejitve obdelave</li>
            <li>Pravico do prenosljivosti podatkov</li>
            <li>Pravico do ugovora obdelavi</li>
          </ul>
          <p>Za uveljavljanje teh pravic ali za kakršne koli druge informacije v zvezi z obdelavo vaših osebnih podatkov nas kontaktirajte na spodaj navedene kontaktne podatke.</p>
          
          <h3 className="text-xl font-bold mt-8 mb-4">7. Piškotki</h3>
          <p>Naša spletna stran uporablja piškotke za izboljšanje vaše uporabniške izkušnje. Piškotki so majhne tekstovne datoteke, ki se shranijo na vašo napravo, ko obiščete našo spletno stran. Uporabljamo jih za:</p>
          <ul>
            <li>Zagotavljanje pravilnega delovanja spletne strani</li>
            <li>Izboljšanje hitrosti in varnosti spletne strani</li>
            <li>Spremljanje obiska spletne strani za analitične namene</li>
          </ul>
          <p>Večina brskalnikov vam omogoča, da sprejmete ali zavrnete piškotke. Če ne želite sprejeti piškotkov, lahko to nastavite v svojem brskalniku, vendar to lahko vpliva na vašo uporabniško izkušnjo.</p>
          
          <h3 className="text-xl font-bold mt-8 mb-4">8. Spremembe politike zasebnosti</h3>
          <p>Ta politika zasebnosti se lahko občasno spremeni. O vseh spremembah vas bomo obvestili z objavo nove politike zasebnosti na tej strani. Priporočamo, da redno preverjate to politiko zasebnosti za morebitne spremembe.</p>
          
          <h3 className="text-xl font-bold mt-8 mb-4">9. Kontaktni podatki</h3>
          <p>Če imate kakršna koli vprašanja v zvezi s to politiko zasebnosti ali obdelavo vaših osebnih podatkov, nas kontaktirajte:</p>
          <p>
            Dr. Danijel Novak<br />
            Rožna ulica 7<br />
            1000 Ljubljana<br />
            Slovenija<br />
            E-pošta: info@danijelnovak.si<br />
            Telefon: +386 41 123 456
          </p>
          
          <p className="mt-8 text-gray-600 italic">Zadnja posodobitev: 12. maj, 2024</p>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPage;